export { default as GDMLink } from './GDMLink';

export type { GDMLinkComponent, GDMLinkProps } from './GDMLink.type';
